import axios from "axios";

export default ({
  get(route) {
    let headers = localStorage.getItem("access_token") ? {
      headers: { 'Authorization': localStorage.getItem("access_token") }
    } : null

    return new Promise((resolve, reject) => {
      axios.get(process.env.VUE_APP_API_URI + route, headers).then(function (response) {
        resolve(response)
      }).catch((err) => {
        if (err) reject(err)
      })
    })
  },

  post(route, body = {}, isUpload = false) {
    let headers = !isUpload ? {
      headers:
        { 'Authorization': localStorage.getItem('access_token') }
    } : {
        headers: {
          'Authorization': localStorage.getItem('access_token'),
          "Content-Type": "multipart/form-data",
        }
      }

    return new Promise((resolve, reject) => {
      axios.post(process.env.VUE_APP_API_URI + route, body, headers
      ).then(function (response) {
        resolve(response)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  patch(route, body = {}) {
    let headers = localStorage.getItem("access_token") ? {
      headers: { 'Authorization': localStorage.getItem("access_token") }
    } : null

    return new Promise((resolve, reject) => {
      axios.patch(process.env.VUE_APP_API_URI + route, body, headers
      ).then(function (response) {
        resolve(response)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  put(route, body = {}) {
    let headers = localStorage.getItem("access_token") ? {
      headers: { 'Authorization': localStorage.getItem("access_token") }
    } : null

    return new Promise((resolve, reject) => {
      axios.put(process.env.VUE_APP_API_URI + route, body, headers
      ).then(function (response) {
        resolve(response)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  delete(route) {
    let headers = localStorage.getItem("access_token") ? {
      headers: { 'Authorization': localStorage.getItem("access_token") }
    } : null

    return new Promise((resolve, reject) => {
      axios.delete(process.env.VUE_APP_API_URI + route, headers).then(function (response) {
        resolve(response)
      }).catch((err) => {
        reject(err)
      })
    })
  },

})